export function setCategorias(state, categorias) {
    state.categorias = categorias;
}

export function setCategoriaSelec(state, categoria) {
    state.categoriaSelec = categoria;
}

export function actListCategorias(state, categoria) {
    if (categoria !== null) {
        const index = state.categorias.findIndex(r => r.id === categoria.id)
        if (index != -1) {
            state.categorias[index].titulo = categoria.titulo;
            state.categorias[index].subtitulo = categoria.subtitulo;
            state.categorias[index].descripcion = categoria.descripcion;
            state.categorias[index].orden = categoria.orden;
        }
    }
}

export function actListCaminosFromCategorias(state, camino) {
    if (camino !== null) {
        for (let i = 0; i < state.categorias.length; i++) {
            const index = state.categorias[i].caminos.findIndex(r => r.id === camino.id)
            if (index != -1) {
                state.categorias[i].caminos[index].codigo = camino.codigo;
                state.categorias[i].caminos[index].titulo = camino.titulo;
                state.categorias[i].caminos[index].subtitulo = camino.subtitulo;
                state.categorias[i].caminos[index].descripcion = camino.descripcion;

                state.categorias[i].caminos[index].titulo_EN = camino.titulo_EN;
                state.categorias[i].caminos[index].subtitulo_EN = camino.subtitulo_EN;
                state.categorias[i].caminos[index].descripcion_EN = camino.descripcion_EN;

                state.categorias[i].caminos[index].titulo_DE = camino.titulo_DE;
                state.categorias[i].caminos[index].subtitulo_DE = camino.subtitulo_DE;
                state.categorias[i].caminos[index].descripcion_DE = camino.descripcion_DE;

                state.categorias[i].caminos[index].orden = camino.orden;
                state.categorias[i].caminos[index].distancia = camino.distancia;
                state.categorias[i].caminos[index].dificultad = camino.dificultad;
                state.categorias[i].caminos[index].duracion = camino.duracion;
                state.categorias[i].caminos[index].precio = camino.precio;
                state.categorias[i].caminos[index].etapas = camino.etapas;
                state.categorias[i].caminos[index].subcategoria_id = camino.subcategoria_id;
                state.categorias[i].caminos[index].subcategoria_titulo = camino.subcategoria_titulo;
            }
        }
    }
}

export function actListEtapasFromCaminosFromCategorias(state, etapa) {
    if (etapa !== null) {
        for (let k = 0; k < state.categorias.length; k++) {
            for (let i = 0; i < state.categorias[k].caminos.length; i++) {
                const index = state.categorias[k].caminos[i].etapas.findIndex(e => e.id === etapa.id)
                if (index != -1) {
                    state.categorias[k].caminos[i].etapas[index].titulo = etapa.titulo;
                    state.categorias[k].caminos[i].etapas[index].imagen_base64 = etapa.imagen_base64;
                    state.categorias[k].caminos[i].etapas[index].descripcion = etapa.descripcion;
                    state.categorias[k].caminos[i].etapas[index].descripcion_EN = etapa.descripcion_EN;
                    state.categorias[k].caminos[i].etapas[index].descripcion_DE = etapa.descripcion_DE;
                    state.categorias[k].caminos[i].etapas[index].inicio_punto = etapa.inicio_punto;
                    state.categorias[k].caminos[i].etapas[index].final_punto = etapa.final_punto;
                    state.categorias[k].caminos[i].etapas[index].dificultad = etapa.dificultad;
                    state.categorias[k].caminos[i].etapas[index].distancia = etapa.distancia;
                    state.categorias[k].caminos[i].etapas[index].duracion = etapa.duracion;
                }
            }
        }
    }
}

export function actDeleteListCategorias(state, id) {
    if (id != null) {
        const index = state.categorias.findIndex(r => r.id === id)
        if (index != -1) {
            state.categorias.splice(index, 1)
        }
    }
}

export function actDeleteListCaminosFromCategorias(state, id) {
    if (id != null) {
        for (let i = 0; i < state.categorias.length; i++) {
            const index = state.categorias[i].caminos.findIndex(r => r.id === id)
            if (index != -1) {
                state.categorias[i].caminos.splice(index, 1)
            }
        }
    }
}